@let details = signUpDetails();

@if(details?.mentorSchedule; as schedule){
<schedule-viewer-part [userType]="'Volunteer'" [meetings]="schedule" [timeZoneId]="details.standardFourTimeZoneId" [canEdit]="dialogDataService.canEdit()"
	(saved)="dialogDataService.getVolunteerSignupMentorData(details.volunteerSignupMentorId)">
</schedule-viewer-part>
} @else {
<common-message alertType='warning'>
	No Schedule added for this Volunteer, edit ability coming soon!
</common-message>
}